import React, { useEffect, useState } from "react";
import ViewModal from "@core/modals/ViewModal";
import ViewButton from "@core/buttons/atoms/ViewButton";
import RowDetails from "@hoc/cruds/RowDetails";
import { useTranslation } from "react-i18next";
import PermissionHandler from "@hoc/cruds/PermissionHandler";
import DisposalTypeService from "@services/DisposalTypeService";

const ShowDisposalType = ({ disposalType }) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [disposalTypeData, setDisposalTypeData] = useState([]);

  const closeModal = () => {
    setShowModal(false);
  };
  useEffect(() => {
    if (showModal)
      DisposalTypeService.find(disposalType.id).then((response) => {
        setDisposalTypeData(response.data.data);
      });
  }, [disposalType.id, showModal]);

  return (
    <PermissionHandler permission={"view_disposal_types"}>
      <ViewButton onClick={() => setShowModal(true)} />
      <ViewModal
        show={showModal}
        title={`${t("overview")}`}
        onClose={closeModal}
      >
        <div className="flex flex-col mt-5">
          <RowDetails label={t("name")} value={disposalTypeData.name} />
          <RowDetails label={t("nameEng")} value={disposalTypeData.name_eng} />
          <RowDetails
            label={t("description")}
            value={disposalTypeData.description}
          />
        </div>
      </ViewModal>
    </PermissionHandler>
  );
};

export default ShowDisposalType;
